<template lang="pug">
  div
    v-avatar.avatar-shadow.mt-4.mb-8.pa-4(size="100" color="info500")
      .d-flex.flex-column
        .text-xl.white--text.font-semibold {{ stampCount }}
        .text-lg.white--text {{ 'Stamp' | pluralize({ count:stampCount }) }}
    .text-lg.font-semibold.mb-4.neutral700--text {{ name }} has achieved {{ stampCount }} {{ 'stamp' | pluralize({ count:stampCount }) }}!
</template>

<script>

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    stampCount: {
      type: Number,
      default: 0
    },
  },
}
</script>

<style scoped>
.avatar-shadow {
  box-shadow: 0 0 20px 18px rgba(163, 200, 255, 0.85);
  -webkit-box-shadow: 0 0 20px 18px rgba(163, 200, 255, 0.85);
  -moz-box-shadow: 0 0 20px 18px rgba(163, 200, 255, 0.85);
}
</style>